export function isEmpty<T>(array: T[]): boolean {
	return Array.isArray(array) && array.length === 0;
}

export function sum(array: number[]): number {
	return array.reduce((current, sum) => current + sum, 0);
}

export function removeZeroIds<T extends { id?: number | null }>(arr: T[]) {
	if (!arr) return;

	for (const item of arr) {
		if (item.id === 0) delete item.id;
	}
}

export function convertListIntoKeyValueMap<T extends object, K extends keyof T>(
	list: T[],
	valueField: K,
	labelField: K
): Map<string, string> {
	return list.reduce((map, item) => {
		const value = String(item[valueField]);
		const label = String(item[labelField]);

		if (
			value &&
			(typeof item[valueField] === "string" || typeof item[valueField] === "number") &&
			label &&
			(typeof item[labelField] === "string" || typeof item[labelField] === "number")
		)
			map.set(value, label);

		return map;
	}, new Map<string, string>());
}
